import { ReactNode } from 'react';

import { GTMProvider } from './gtmContext/gtmContext';
import { MixpanelProvider } from './mixpanelContext';

const TrackerProvider = ({ children }: { children?: ReactNode }) => {
  return (
    <MixpanelProvider>
      <GTMProvider>{children}</GTMProvider>
    </MixpanelProvider>
  );
};

export default TrackerProvider;
